/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	AnalyticsAdditionalQuestionsAnalyticsPathParams,
	AnalyticsAdditionalQuestionsAnalyticsQueryParams,
	AnalyticsAdditionalQuestionsAnalyticsResponse,
} from '../types/AnalyticsAdditionalQuestionsAnalytics'

/**
 * GET /campaigns/:campaign/additional-questions-analytics
 * @see backend/nexus/modules/Analytics/Http/Controllers/AnalyticsController.php AnalyticsController::additionalQuestionsAnalytics
 */
export async function analyticsAdditionalQuestionsAnalytics(
	campaign: AnalyticsAdditionalQuestionsAnalyticsPathParams['campaign'],
	params?: AnalyticsAdditionalQuestionsAnalyticsQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AnalyticsAdditionalQuestionsAnalyticsResponse>> {
	return axiosInstance.get(`/campaigns/${campaign}/additional-questions-analytics`, { params, ...config })
}
